import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';

import { AppFacade } from '@app/core/app-services';

@Component({
  selector: 'ingo-global-error-container',
  template: `
    <ingo-global-error
      [error]="error$ | async"
      (onReload)="reload()"
      (onClose)="close()">
    </ingo-global-error>`
})
export class GlobalErrorContainerComponent implements OnInit {

  error$: Observable<boolean>;

  constructor(private appFacade: AppFacade) { }

  ngOnInit() {
    this.error$ = this.appFacade.getError();
  }

  reload(): void {
    location.reload();
  }

  close(): void {
    this.appFacade.resetError();
  }
}
